import { Documentation } from 'graphql-common';
import { DocumentReadRecord } from 'components/TaskCompletionForm/DocumentQuestionField';

/**
 * Whether a DOCUMENT-question option's read requirement is satisfied for the
 * current user. True when either:
 * - the user marked-as-read in this session (entry in `readRecords`), or
 * - the BE-derived `Documentation.read` flag is `true` (set only by an
 *   explicit `documentationVersionMarkAsRead` confirmation covering a version
 *   `>= lastRequiredRereadVersionNumber`).
 *
 * Drives the per-option Unread chip, the per-option "Please read the
 * document" inline error, and the per-field Yup validity in
 * `TaskCompletionCreateContainer`. `processDocument` (`getAnswers.ts`)
 * branches on the same predicate to choose between `READ` (in-session, has
 * `documentationVersionViewId`) and `READ_PREVIOUSLY` (server-acknowledged).
 */
export default function isDocOptionSatisfied(
  docId: string,
  doc: Documentation | undefined,
  readRecords: Record<string, DocumentReadRecord>,
): boolean {
  if (readRecords[docId]) return true;
  return doc?.read === true;
}
